import React, { useRef } from "react";
import useResponsive from "~src/hooks/useResponsive";
import { logError, logInfo } from "~src/utils/logger";//-------------------------------------------------------------------------------------------------

type VideoPlayerProps = {
  sourceUrl: string;
};

export default function VideoPlayer({ sourceUrl }: VideoPlayerProps) {
  const isDesktop = useResponsive("up", "lg");
  const videoRef = useRef<HTMLVideoElement | null>(null);

  if (!sourceUrl || sourceUrl === "N/A") {
    return null;
  }

  const getSourceURL = () => {
    if (!isDesktop) {
      return `${sourceUrl}#t=0.001`;
    }
    return sourceUrl;
  };
  
  const stopPropagation = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  // Safely handle metadata loading
  const handleMetadataLoaded = () => {
    try {
      const video = videoRef.current;
      // Safely access duration only if video is available
      if (video && video.duration) {
        logInfo(`Video duration: ${video.duration}`);
      }
    } catch (error) {
      logError(`Error accessing video metadata: ${error}`);
    }
  };

  return (
    <video
      ref={videoRef}
      onClick={stopPropagation}
      key={sourceUrl}
      loop
      controls
      muted
      onLoadedMetadata={handleMetadataLoaded}
      data-testid="video-player"
      style={{
        width: "100%",
        height: "100%",
        display: "block",
      }}
    >
      <source src={getSourceURL()} type="video/mp4" />
    </video>
  );
}
